// removed by extract-text-webpack-plugin
module.exports = {"small":"c-SummaryRow__small","label":"c-SummaryRow__label","smaller":"c-SummaryRow__smaller","row":"c-SummaryRow__row","value":"c-SummaryRow__value","total":"c-SummaryRow__total"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SummaryRow/SummaryRow.scss
// module id = 833
// module chunks = 0